import { ElasticModalForm } from "../modals/ElasticModal";
import { SplunkModalForm } from "../modals/SplunkModal";
import { CoralogixModalForm } from "../modals/CoralogixModal";
import { GlobalRelayModalForm } from "../modals/GlobalRelayModal";
import { CustomS3ModalForm } from "../modals/CustomS3Modal";
import { R2ModalForm } from "../modals/R2Modal";
import { AzureBlobModalForm } from "../modals/AzureBlobModal";
import { SalesforceModalForm } from "../modals/SalesforceModal";
import { InternalS3ModalForm } from "../modals/InternalS3Modal";
import { VerintModalForm } from "../modals/VerintModal";
import { GoogleCloudStorageModalForm } from "../modals/GoogleCloudStorageModal";
import { QradarModalForm } from "../modals/QradarModal";
import { DynamicsModalForm } from "../modals/DynamicsModal";
import { DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import { AmazonTranscribeModalForm } from "../modals/AmazonTranscribeModal";
import { AzureSpeechTranscribeModalForm } from "../modals/AzureSpeechTranscribeModal";
import { SFTPModalForm } from "../modals/SFTPModal";
import { ProofPointModalForm } from "../modals/ProofPointModal";
import { InternalMongoDbModalForm } from "../modals/InternalMongoDbModal";
import { CrowdstrikeModalForm } from "../modals/CrowdstrikeModal";
import { SalesforceDataCloudModalForm } from "../modals/SalesforceDataCloudModal";
import { HubspotModalForm } from "../modals/HubspotModal";
import { PipedriveModalForm } from "../modals/PipedriveModal";
import { ForcepointDlpDetectorModalForm } from "../modals/ForcepointDlpDetectorModal";
import type { UserType } from "@whatslly/types/User";
import keyBy from "lodash/keyBy";
import { MicrosoftPurviewModalForm } from "../modals/MicrosoftPurviewModal";
import { SentinelModalForm } from "../modals/SentinelModal";
import { OpenAiModalForm, AnthropicModalForm, GoogleAiModalForm } from "../modals/ApiKeyProviderModal";
import { AzureOpenAiModalForm } from "../modals/AzureOpenAiModal";
import { BedrockModalForm } from "../modals/BedrockModal";
import { InternalAzureOpenAiModalForm } from "../modals/InternalAzureOpenAiModal";
import type { DestinationListEntry } from "./DestinationsListTypes";
import { GoogleSecOpsModalForm } from "../modals/GoogleSecOpsForm";

const SecurityPlaceholderForm = () => null;

export const DestinationList: DestinationListEntry[] = [
  {
    id: "pipedrive",
    name: "Pipedrive",
    category: "CRM",
    form: PipedriveModalForm,
    type: "pipedrive",
    img: "https://assets.whatslly.com/product/img/logos/destination-pipedrive.png",
    className: "pipedrive",
    wrapperClassName: "centerContent",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "hubspot",
    name: "Hubspot",
    category: "CRM",
    form: HubspotModalForm,
    type: "hubspot",
    img: "https://assets.whatslly.com/product/img/logos/destination-hubspot.png",
    className: "hubspot",
    wrapperClassName: "centerContent",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "openai",
    name: "OpenAI",
    category: "LLM Provider",
    form: OpenAiModalForm,
    type: "openai",
    img: "https://assets.whatslly.com/product/img/logos/destination-openai.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "anthropic",
    name: "Anthropic",
    category: "LLM Provider",
    form: AnthropicModalForm,
    type: "anthropic",
    img: "https://assets.whatslly.com/product/img/logos/destination-anthropic.svg",
    className: "anthropic-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "google-ai",
    name: "Google AI",
    category: "LLM Provider",
    form: GoogleAiModalForm,
    type: "google",
    img: "https://assets.whatslly.com/product/img/logos/destination-google-ai.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "azure-openai",
    name: "Azure OpenAI",
    category: "LLM Provider",
    form: AzureOpenAiModalForm,
    type: "azure_openai",
    img: "https://assets.whatslly.com/product/img/logos/destination-azure-openai.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "bedrock",
    name: "Amazon Bedrock",
    category: "LLM Provider",
    form: BedrockModalForm,
    type: "bedrock",
    img: "https://assets.whatslly.com/product/img/logos/destination-aws-2.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "internal-azure-openai",
    name: "Internal Azure OpenAI",
    category: "LLM Provider",
    form: InternalAzureOpenAiModalForm,
    type: "internalAzureOpenAi",
    img: "https://assets.whatslly.com/product/img/logos/destination-azure-openai.svg",
    className: "llm-img",
    wrapperClassName: "centerContent",
    isActive: (user: UserType | undefined) => user?.isSuperAdmin || user?.isAdmin || import.meta.env.MODE === "test",
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "azure-ai-speech",
    name: "Azure AI Speech",
    category: "",
    form: AzureSpeechTranscribeModalForm,
    type: "azureSpeechTranscribe",
    img: "https://assets.whatslly.com/product/img/logos/destination-azspeech.png",
    className: "amazon-trascribe-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIO_TRANSCRIBES,
  },
  {
    id: "amazon-transcribe",
    name: "Amazon Transcribe",
    category: "",
    form: AmazonTranscribeModalForm,
    type: "amazonTranscribe",
    img: "https://assets.whatslly.com/product/img/logos/destination-amazon-transcribe.png",
    className: "amazon-trascribe-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIO_TRANSCRIBES,
  },
  // TODO make it work with batch processing
  // {
  //   name: "Redshift",
  //   category: "",
  //   modal: RedshiftModal,
  //   type: "redshift",
  //   img: "https://assets.whatslly.com/product/img/logos/destionation-amazon-redshift.jpg",
  //   className: "amazon-redshift",
  //   isActive: () => true,
  //   integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  // },
  {
    id: "google-sec-ops-audit-log",
    name: "Google SecOps",
    category: "destinations_page.compliance",
    form: GoogleSecOpsModalForm,
    type: "googleSecOpsAuditLog",
    img: `https://assets.whatslly.com/product/img/logos/destination-google-sec-ops.png`,
    className: "google-sec-ops-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "google-sec-ops-dlp-incident",
    name: "Google SecOps",
    category: "destinations_page.compliance",
    form: GoogleSecOpsModalForm,
    type: "googleSecOpsDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destination-google-sec-ops.png",
    className: "google-sec-ops-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "splunk-audit-log",
    name: "Splunk",
    category: "destinations_page.compliance",
    form: SplunkModalForm,
    type: "splunkAuditLog",
    img: "https://assets.whatslly.com/product/img/logos/destination-splunk.svg",
    className: "splunk-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "splunk-dlp-incident",
    name: "Splunk",
    category: "destinations_page.compliance",
    form: SplunkModalForm,
    type: "splunkDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destination-splunk.svg",
    className: "splunk-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "elastic-audit-log",
    name: "Elastic",
    category: "destinations_page.compliance",
    form: ElasticModalForm,
    type: "elasticAuditLog",
    img: "https://assets.whatslly.com/product/img/logos/destionation-elasticsearch.svg",
    className: "elasticsearch-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "elastic-dlp-incident",
    name: "Elastic",
    category: "destinations_page.compliance",
    form: ElasticModalForm,
    type: "elasticDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destionation-elasticsearch.svg",
    className: "elasticsearch-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "salesforce",
    name: "Salesforce",
    category: "CRM",
    form: SalesforceModalForm,
    type: "salesforce",
    img: "https://assets.whatslly.com/product/img/salesforce-icon.png",
    className: "salesforce-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "salesforce-data-cloud",
    name: "Salesforce Data Cloud",
    category: "Warehouse",
    form: SalesforceDataCloudModalForm,
    type: "salesforceDataCloud",
    img: "https://assets.whatslly.com/product/img/salesforce-icon.png",
    className: "salesforce-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "microsoft-dynamics",
    name: "Microsoft Dynamics",
    category: "CRM",
    form: DynamicsModalForm,
    type: "dynamics",
    img: "https://assets.whatslly.com/product/img/dynamics_logo.svg",
    className: "dynamics-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "crowdstrike-siem",
    name: "CrowdStrike SIEM",
    category: "destinations_page.compliance",
    form: CrowdstrikeModalForm,
    type: "crowdstrike",
    img: "https://assets.whatslly.com/product/img/logos/destination-crowdstrike.png",
    className: "crowdstrike-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "splunk",
    name: "Splunk",
    category: "destinations_page.compliance",
    form: SplunkModalForm,
    type: "splunk",
    img: "https://assets.whatslly.com/product/img/logos/destination-splunk.svg",
    className: "splunk-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "coralogix",
    name: "Coralogix",
    category: "destinations_page.compliance",
    form: CoralogixModalForm,
    type: "coralogix",
    img: "https://assets.whatslly.com/product/img/logos/destination-coralogix-2.png",
    className: "coralogix-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "global-relay",
    name: "Global Relay",
    category: "destinations_page.compliance",
    form: GlobalRelayModalForm,
    type: "smtp",
    img: "https://assets.whatslly.com/product/img/logos/destination-globalrelay.png",
    className: "smtp-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "forcepoint",
    name: "Forcepoint",
    category: "destinations_page.compliance",
    form: ForcepointDlpDetectorModalForm,
    type: "forcepointDlpDetector",
    img: "https://assets.whatslly.com/product/img/logos/destination-forcepoint.svg",
    className: "forcepoint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_DETECTORS,
  },
  {
    id: "microsoft-purview",
    name: "Microsoft Purview",
    category: "destinations_page.compliance",
    form: MicrosoftPurviewModalForm,
    type: "microsoftPurviewDlpDetector",
    img: "https://assets.whatslly.com/product/img/logos/destination-purview.png",
    className: "purview-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_DETECTORS,
  },
  {
    id: "proofpoint",
    name: "Proofpoint",
    category: "destinations_page.compliance",
    form: ProofPointModalForm,
    type: "proofpoint",
    img: "https://assets.whatslly.com/product/img/logos/destionation-proofpoint.png",
    className: "proofpoint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "amazon-s3",
    name: "Amazon S3",
    category: "destinations_page.blob_storage",
    form: CustomS3ModalForm,
    type: "customS3",
    img: "https://assets.whatslly.com/product/img/logos/destination-aws-2.svg",
    className: "customS3-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "cloudflare-r2",
    name: "Cloudflare R2",
    category: "destinations_page.blob_storage",
    form: R2ModalForm,
    type: "r2",
    img: "https://assets.whatslly.com/product/img/logos/destination-cloudflare-r2.svg",
    className: "r2-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "sftp",
    name: "SFTP",
    category: "destinations_page.blob_storage",
    form: SFTPModalForm,
    type: "sftp",
    img: "https://assets.whatslly.com/product/img/logos/destination-sftp.png",
    className: "sftp-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "internal-amazon-s3",
    name: "Internal Amazon S3",
    category: "destinations_page.blob_storage",
    form: InternalS3ModalForm,
    type: "internalS3",
    img: "https://assets.whatslly.com/product/img/logos/destination-aws-2.svg",
    className: "customS3-img",
    isActive: (user: UserType | undefined) => user?.isSuperAdmin || user?.isAdmin || import.meta.env.MODE === "test",
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "azure-storage",
    name: "Azure Storage",
    category: "destinations_page.blob_storage",
    form: AzureBlobModalForm,
    type: "azureBlob",
    img: "https://assets.whatslly.com/product/img/logos/destination-azure.svg",
    className: "azureBlob-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "verint",
    name: "Verint",
    category: "destinations_page.compliance",
    form: VerintModalForm,
    type: "verint",
    img: "https://assets.whatslly.com/product/img/logos/destination-verint.svg",
    className: "verint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "google-cloud-storage",
    name: "Google Cloud Storage",
    category: "destinations_page.blob_storage",
    form: GoogleCloudStorageModalForm,
    type: "googleCloudStorage",
    img: "https://assets.whatslly.com/product/img/logos/destination-google-cloud-storage.svg",
    className: "customS3-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "qradar",
    name: "QRadar",
    category: "destinations_page.compliance",
    form: QradarModalForm,
    type: "qradar",
    img: "https://assets.whatslly.com/product/img/logos/destination-qradar.png",
    className: "qradar-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "qradar-audit-log",
    name: "QRadar",
    category: "destinations_page.compliance",
    form: QradarModalForm,
    type: "qradarAuditLog",
    img: "https://assets.whatslly.com/product/img/logos/destination-qradar.png",
    className: "qradar-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "qradar-dlp-incident",
    name: "QRadar",
    category: "destinations_page.compliance",
    form: QradarModalForm,
    type: "qradarDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destination-qradar.png",
    className: "qradar-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "sentinel-dlp-incident",
    name: "Microsoft Sentinel",
    category: "destinations_page.compliance",
    form: SentinelModalForm,
    type: "sentinelDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/microsoft-sentinel-logo.jpg",
    className: "sentinel-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "internal-mongo-db",
    name: "Internal Mongo DB",
    category: "destinations_page.blob_storage",
    form: InternalMongoDbModalForm,
    type: "internalMongoDb",
    img: "https://assets.whatslly.com/product/img/logos/destination-mongodb.png",
    className: "customS3-img",
    wrapperClassName: "centerContent",
    isActive: (user: UserType | undefined) => user?.isSuperAdmin || user?.isAdmin || import.meta.env.MODE === "test",
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "palo-alto-firewall",
    name: "Palo Alto",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "paloAltoFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-palo-alto-firewall.png",
    className: "paloAlto-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "checkpoint-firewall",
    name: "Checkpoint",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "checkpointFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-checkpoint.svg",
    className: "checkpoint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "sentinel-one-firewall",
    name: "Sentinel One",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "sentinelOneFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-sentinel-one-firewall.png",
    className: "sentinelOne-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "skyhigh-proxy",
    name: "Skyhigh",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "skyhighProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-skyhigh.png",
    className: "skyhigh-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "netskope-casb-proxy",
    name: "Netskope (CASB)",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "netskopeCasbProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-netskope.webp",
    className: "netskope-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "crowdstrike-endpoint-protection",
    name: "CrowdStrike",
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "crowdStrikeEndpointProtection",
    img: "https://assets.whatslly.com/product/img/logos/destination-crowdstrike.png",
    className: "crowdstrikeSecurity-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "broadcom-proxysg-proxy",
    name: "Broadcom/Symantec/VMWare/Bluecoat (ProxySG)",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "broadcomProxySg",
    img: "https://assets.whatslly.com/product/img/logos/destination-broadcom.png",
    className: "broadcom-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "forcepoint-proxy-websecurity",
    name: "Forcepoint (Proxy WebSecurity)",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "forcepointProxyWebSecurity",
    img: "https://assets.whatslly.com/product/img/logos/destination-forcepoint.png",
    className: "forcepointSecurity-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "fortinet-fortigate-proxy",
    name: "Fortinet (Fortigate)",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "fortinetFortigateProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-fortinet.webp",
    className: "fortinet-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "trellix-proxy",
    name: "Trellix",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "trellixProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-trellix.png",
    className: "trellix-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "trend-micro-ee-endpoint-protection",
    name: "Trend Micro (Ee)",
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "trendMicroEeEndpointProtection",
    img: "https://assets.whatslly.com/product/img/logos/destination-trend-micro.png",
    className: "trendMicro-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "kaspersky-endpoint",
    name: "Kaspersky",
    category: "Endpoint",
    form: SecurityPlaceholderForm,
    type: "kasperskyEndpoint",
    img: "https://assets.whatslly.com/product/img/logos/destination-kaspersky.png",
    className: "kaspersky-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
] as const;

export const DestinationListMap = keyBy(DestinationList, "type");
export const DestinationListMapById = keyBy(DestinationList, "id");
